const escalationDataFragment = `
    fragment EscalationData on HISTORICAL_HistoricalRateEscalationPublic {
        timeEscalation
        rates {
            trip {
                date
                average
                range {
                    high
                    low
                }
            }
            mile {
                date
                average
                range {
                    high
                    low
                }
            }
        }
        timeInterval
        mileage
        reports
        companies
        escalationOrigin
        escalationDestination
    }`;

const escalationMapFragment = `
    fragment EscalationMap on HISTORICAL_RateEscalationMapHistorical {
        threedays(query: $historicalQuery) {
            ...EscalationData
        }
        sevendays(query: $historicalQuery) {
            ...EscalationData
        }
        fifteendays(query: $historicalQuery) {
            ...EscalationData
        }
        thirtydays(query: $historicalQuery) {
            ...EscalationData
        }
        sixtydays(query: $historicalQuery) {
            ...EscalationData
        }
        ninetydays(query: $historicalQuery) {
            ...EscalationData
        }
        onehundredeightydays(query: $historicalQuery) {
            ...EscalationData
        }
        oneyear(query: $historicalQuery) {
            ...EscalationData
        }
    }`;

export const getHistoricalRatesDataQuery = `
    ${escalationDataFragment}
    ${escalationMapFragment}
    query (
        $historicalQuery: HISTORICAL_SearchCriteriaInputHistorical
    ) {
        rate: getHistorical(query: $historicalQuery) {
            average: avgAverage {
                perTrip {
                    value: average
                }
                perMile {
                    value: average
                }
            }
            high: avgHigh {
                perTrip {
                    value: average
                }
                perMile {
                    value: average
                }
            }
            low: avgLow {
                perTrip {
                    value: average
                }
                perMile {
                    value: average
                }
            }
            mileage
            companies
            reports
            timeEscalation
            area
            areaDestination
            escalationMap {
                ...EscalationMap
            }
        }
    }
`;